import { HttpService, L10nBase, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';

export interface SaleCommunityTransactionItem {
    readonly availableForNotVatPayer: boolean;
    readonly default: boolean;
    readonly defaultVatRateId?: number;
    readonly id: number;
    readonly name: string;
    readonly reverseCharge: boolean;
    readonly symbol: SaleCommunityTransactionSymbol;
}

interface SaleCommunityTransactionInternalItem {
    readonly availableForNotVatPayer: boolean;
    readonly default: boolean;
    readonly defaultVatRateId?: number;
    readonly id: number;
    readonly name: string;
    readonly reverseCharge: boolean;
    readonly symbol: SaleCommunityTransactionSymbol;
    readonly translationKey: string;
}

export type SaleCommunityTransactionSymbol = 'SK' | 'ŚUPTK' | 'WDT' | 'ET' | 'OO' | 'DPTK' | 'WSTO-OSS' | 'WSTO-SK';

export class CommunityTransactionForSaleQuery extends Query<SaleCommunityTransactionItem[]> { }

export class CommunityTransactionForSaleQueryHandlerBase implements QueryHandler<CommunityTransactionForSaleQuery, SaleCommunityTransactionItem[]> {
    private static Url = TaggedUrl.join('sales/communityTransactions', [Tags.Api]);

    public constructor(
        private readonly http: HttpService,
        private readonly translate: L10nBase
    ) { }

    public async handleAsync(_: CommunityTransactionForSaleQuery): Promise<SaleCommunityTransactionItem[]> {
        const { data: { items } } = await this.http.get<{ items: SaleCommunityTransactionInternalItem[] }>(CommunityTransactionForSaleQueryHandlerBase.Url);
        return items.map(item => ({
            id: item.id,
            availableForNotVatPayer: item.availableForNotVatPayer,
            default: item.default,
            defaultVatRateId: item.defaultVatRateId,
            name: this.translate.instant(`business.community-transactions.${item.translationKey}.name`),
            reverseCharge: item.reverseCharge,
            symbol: item.symbol
        }));
    }
}
